export default __webpack_public_path__ + "static/media/cleaning_image.174222fc.jpeg";